<div class='top-runner'>
    <h1>JICS</h1>
    <h2>Transaction Runner</h2>
    <table>
        <tr></tr>
        <tr>
            <td><input [(ngModel)]="transid" (keyup.enter)="runTransaction()" placeholder="" autofocus="autofocus" /></td>
            <td><button (click)="runTransaction()">Run</button></td>
        </tr>
    </table>
</div>